import { FAULT_RESET_TYPES, FAULT_TYPES } from '../../constants/protocol';

const tgsResetPayload = (faultType) => {
  switch (faultType) {
    case FAULT_TYPES.THERMOCOUPLE:
      return { thermocouple_fault_reset: 0 };
    case FAULT_TYPES.BMS:
      return { fault_reset: 1, fault_reset_type: FAULT_RESET_TYPES.BMS };
    case FAULT_TYPES.HPLP:
      return { fault_reset: 1, fault_reset_type: FAULT_RESET_TYPES.HPLP };
    case FAULT_TYPES.TIMEOUT:
      return { fault_reset: 1, fault_reset_type: FAULT_RESET_TYPES.TIMEOUT };
    default:
      return null;
  }
};

const electricResetPayload = (faultType, faultNumber) => {
  switch (faultType) {
    case FAULT_TYPES.SSR:
      return { ssr_no: faultNumber - 1, ssr_reset: 0 };
    case FAULT_TYPES.SSR_OVER_CURRENT:
      return { ssr_no: faultNumber - 1, Load_exceeded_reset: 0 };
    case FAULT_TYPES.THERMOCOUPLE:
      return { tc_no: faultNumber - 1, thermocouple_reset: 0 };
    case FAULT_TYPES.GROUND:
      return { fault_reset: 1, fault_reset_type: FAULT_RESET_TYPES.GROUND };
    default:
      return null;
  }
};

/**
 * Keys `useDeviceCommand` sends to reset one fault, or null when the fault has no reset.
 * @param {'ess'|'tgs'|'tes'} system
 * @param {string} faultType  a FAULT_TYPES value
 * @param {number} faultNumber  1-based SSR or thermocouple number
 * @returns {Object<string, number|string>|null}
 */
export const faultResetPayload = (system, faultType, faultNumber) =>
  system === 'tgs'
    ? tgsResetPayload(faultType)
    : electricResetPayload(faultType, faultNumber);
